// import fetch from "node-fetch";

class RecipeDataService {
//   async getYouTubeMetadata(videoId) {
//   const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;

//   const response = await fetch(
//     `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoId}&key=${API_KEY}`
//   );

//   const data = await response.json();

//   const snippet = data.items[0].snippet;

//   return {
//     title: snippet.title,
//     description: snippet.description,
//     thumbnail: snippet.thumbnails.high.url,
//     uploadDate: snippet.publishedAt
//   };
// }
  extractRecipeId(html) {
    const match = html.match(/data-recipe-id="(\d+)"/);
    return match ? match[1] : null;
  }

  extractStepId(html, id) {
    const re = new RegExp(`wprm-recipe-${id}-step="(\\d+)"`);
    const match = html.match(re);
    return match ? match[1] : null;
  }

  // Utility used elsewhere: remove plugin rating <img> and return text
  stripWprmImgFromHtml(html) {
    if (!html) return "";
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      doc.querySelectorAll("img.wprm-comment-rating").forEach((el) => {
        const next = el.nextSibling;
        el.remove();
        if (next && next.nodeType === Node.ELEMENT_NODE && next.tagName.toLowerCase() === "br") {
          next.remove();
        }
      });
      return doc.body.textContent || "";
    } catch (e) {
      return html.replace(/<img[^>]*class=(?:'|")?wprm-comment-rating(?:'|")?[^>]*>\s*(?:<br\s*\/?>)?/gi, "").replace(/<\/?[^>]+(>|$)/g, "");
    }
  }

  extractVideoLink(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const iframe = doc.querySelector("iframe");
    if (iframe) {
      const video = iframe.getAttribute("src");
      var videoId = video.match(/embed\/([^?]+)/);
      // var videoMetaData = this.getYouTubeMetadata(videoId[1]);
      // videoMetaData.id = videoId;
      return videoId;
    }
  }

  // Main extractor (returns instructions as array of { text, id }, and recipe-level fields)
  extractRecipeData(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const ingredients = [...doc.querySelectorAll(".wprm-recipe-ingredient")].map((el) =>
      el.textContent.trim()
    );

    const instructionLis = [...doc.querySelectorAll("li.wprm-recipe-instruction")];

    const instructions = instructionLis.map((li) => {
      const textEl = li.querySelector(".wprm-recipe-instruction-text");
      const text = textEl ? textEl.textContent.trim() : li.textContent.trim();
      const id = li.id || null;
      return { text, id };
    });

    if (!instructions.length) {
      const textNodes = [...doc.querySelectorAll(".wprm-recipe-instruction-text")];
      textNodes.forEach((el) => {
        instructions.push({ text: el.textContent.trim(), id: el.closest("li")?.id ?? null });
      });
    }

    const cuisine = [...doc.querySelectorAll(".wprm-recipe-cuisine")].map((el) => el.textContent.trim());
    const course = [...doc.querySelectorAll(".wprm-recipe-course")].map((el) => el.textContent.trim());
    const equipment = [...doc.querySelectorAll(".wprm-recipe-equipment-list")].map((el) => el.textContent.trim());
    const keywords = [...doc.querySelectorAll(".wprm-recipe-keyword")].map((el) => el.textContent.trim());

    const servings = doc.querySelector(".wprm-recipe-servings")?.textContent?.trim() || null;
    const servingsUnit = doc.querySelector(".wprm-recipe-servings-unit")?.textContent?.trim() || null;

    // Nutrition / calories
    const nutrition = doc.querySelector(".wprm-recipe-nutrition")?.textContent?.trim() || null;
    // try more specific selectors for calories if present
    const calories =
      doc.querySelector(".wprm-recipe-nutrition-calories")?.textContent?.trim() ||
      doc.querySelector(".wprm-nutrition-calories")?.textContent?.trim() ||
      doc.querySelector(".wprm-recipe-nutrition")?.textContent?.trim() ||
      null;

    // Cost field: the plugin outputs .wprm-recipe-cost in many templates
    const cost =
      doc.querySelector(".wprm-recipe-cost")?.textContent?.trim() ||
      doc.querySelector(".wprm-cost")?.textContent?.trim() ||
      null;

    const cookTimeDays = doc.querySelector(".wprm-recipe-cook_time-days")?.textContent?.trim() || null;
    const cookTimeHours = doc.querySelector(".wprm-recipe-cook_time-hours")?.textContent?.trim() || null;
    const cookTimeMinutes = doc.querySelector(".wprm-recipe-cook_time-minutes")?.textContent?.trim() || null;

    const prepTimeDays = doc.querySelector(".wprm-recipe-prep_time-days")?.textContent?.trim() || null;
    const prepTimeHours = doc.querySelector(".wprm-recipe-prep_time-hours")?.textContent?.trim() || null;
    const prepTimeMinutes = doc.querySelector(".wprm-recipe-prep_time-minutes")?.textContent?.trim() || null;

    const customTimeLabel = doc.querySelector(".wprm-recipe-custom-time-label")?.textContent?.trim() || null;
    const customTimeDays = doc.querySelector(".wprm-recipe-custom_time-days")?.textContent?.trim() || null;
    const customTimeHours = doc.querySelector(".wprm-recipe-custom_time-hours")?.textContent?.trim() || null;
    const customTimeMinutes = doc.querySelector(".wprm-recipe-custom_time-minutes")?.textContent?.trim() || null;

    const totalTimeDays = doc.querySelector(".wprm-recipe-total_time-days")?.textContent?.trim() || null;
    const totalTimeHours = doc.querySelector(".wprm-recipe-total_time-hours")?.textContent?.trim() || null;
    const totalTimeMinutes = doc.querySelector(".wprm-recipe-total_time-minutes")?.textContent?.trim() || null;

    const recipeNotes = doc.querySelector(".wprm-recipe-notes")?.textContent?.trim() || null;

    // NEW: Extract WPRM recipe rating average and count if present in the recipe HTML
    const ratingAverage = doc.querySelector(".wprm-recipe-rating-average")?.textContent?.trim() || null;
    const ratingCount = doc.querySelector(".wprm-recipe-rating-count")?.textContent?.trim() || null;

    return {
      ingredients,
      instructions,
      cuisine,
      course,
      equipment,
      keywords,
      servings,
      servingsUnit,
      nutrition,        // generic nutrition text
      calories,         // calories if found
      wprm_cost: cost,  // cost if found
      cookTimeDays,
      cookTimeHours,
      cookTimeMinutes,
      prepTimeDays,
      prepTimeHours,
      prepTimeMinutes,
      customTimeLabel,
      customTimeDays,
      customTimeHours,
      customTimeMinutes,
      totalTimeDays,
      totalTimeHours,
      totalTimeMinutes,
      recipeNotes,
      wprm_recipe_rating_average: ratingAverage !== null ? ratingAverage : null,
      wprm_recipe_rating_count: ratingCount !== null ? ratingCount : null,
    };
  }
}

export default new RecipeDataService();